module.exports = __webpack_public_path__ + "media/images/front/icon_user_del-15fc7fdc8136859f4610e7fbb146b68c.png";